import React, { useState, useEffect } from 'react'
import { InputLabel, Select, MenuItem, Button, Grid, Typography } from '@material-ui/core'
import { useForm , FormProvider } from 'react-hook-form'
import FormInput from './CustomTextField'
import { commerce } from '../../lib/commerce'
import { Link } from 'react-router-dom'


const AddressForm = ({ checkoutToken, next }) => {
  const [ShippingCountries, setShippingCountries] = useState([])
  const [ShippingCountry, setShippingCountry] = useState('')
  const [ShippingSubDivisions, setShippingSubDivisions] = useState([])
  const [ShippingSubDivision, setShippingSubDivision] = useState('')
  const [ShippingOptions, setShippingOptions] = useState([])
  const [ShippingOption, setShippingOption] = useState('')

  const countries = Object.entries(ShippingCountries).map(([code, name]) => ({id: code, label: name}))
  const subdivisions = Object.entries(ShippingSubDivisions).map(([code, name]) => ({id: code, label: name}))
  const options = ShippingOptions.map(s0 => ({ id: s0.id, label: `${s0.description} - (${s0.price.formatted_with_symbol})` }))

  const methods = useForm()

  const fetchShippingCountries = async () => {
    const { countries } =  await commerce.services.localeListShippingCountries(checkoutToken.id)
    // console.log(countries)
    setShippingCountries(countries)
    setShippingCountry(Object.keys(countries)[0])
  }

  const fetchShippingSubDivisions = async (countryCode) => {
    const {subdivisions} = await commerce.services.localeListSubdivisions(countryCode)
    setShippingSubDivisions(subdivisions)
    setShippingSubDivision(Object.keys(subdivisions)[0])
  }

  const fetchShippingOptions = async (checkoutTokenId, country, region = null) => {
    const options = await commerce.checkout.getShippingOptions
    (checkoutTokenId, { country , region })
    setShippingOptions(options)
    setShippingOption(options[0].id)
  }

  useEffect(() => {
    fetchShippingCountries()
  }, [])

  useEffect(() => {
    if(ShippingCountry) fetchShippingSubDivisions(ShippingCountry)
  }, [ShippingCountry])

  useEffect(() => {
    if(ShippingSubDivision) fetchShippingOptions(checkoutToken.id, ShippingCountry, ShippingSubDivision)
  }, [ShippingSubDivision])

  return (
    <>
      <Typography variant="h6" gutterBottom> Shipping Address </Typography>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(data => next({...data, ShippingCountry, ShippingSubDivision, ShippingOption}))}>
          <Grid container spacing={5}>
            <FormInput required fullWidth name="fistName" label="Fist name"/>
            <FormInput required fullWidth name="lastName" label="Last name"/>
            <FormInput required fullWidth name="address" label="Address"/>
            <FormInput required fullWidth name="email" label="Email"/>
            <FormInput required fullWidth name="city" label="City"/>
            <FormInput required fullWidth name="zip" label="ZIP / Postal code"/>
            <Grid item xs={12} sm={6}>
              <InputLabel> Shipping Country </InputLabel>
              <Select value={ShippingCountry} fullWidth onChange={(e) => setShippingCountry(e.target.value)}>
                { countries.map((country) => (
                  <MenuItem key={country.id} value={country.id}>
                    {country.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputLabel> Shipping Divisions </InputLabel>
              <Select value={ShippingSubDivision} fullWidth onChange={(e) => setShippingSubDivision(e.target.value)}>
                { subdivisions.map((subdivision) => (
                  <MenuItem key={subdivision.id} value={subdivision.id}>
                    {subdivision.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs={12} sm={6}>
              <InputLabel> Shipping Options </InputLabel>
              <Select value={ShippingOption} fullWidth onChange={(e) => setShippingOption(e.target.value)}>
              { options.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>
          <br/>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button component={Link} to="/cart" variant="outlined"> Back to Cart </Button>
            <Button type="submit" variant="contained" color="primary"> Next </Button>
          </div>
        </form>
      </FormProvider>
    </>
  )
}

export default AddressForm
